// Demo presets for the Ontario Progress Report Card (pgrc1to6_2023_07).
// Each preset is a complete flat object matching every key in formSchema.
// Values use the exact field value strings expected by PillSelector and fill.js.
// Plan values: "ESLELD" | "IEP" | "NA" | "Core" | "Immersion" | "Extended" | "French" | ""
// Result values: "PWD" | "PW" | "PVW" | ""
// Learning skill values: "E" | "G" | "S" | "N" | ""

export const PRESETS = [
  {
    label: "Example: Aiden Park",
    data: {
      date: "2024-11-15",
      studentName: "Aiden Park",
      oen: "123456789",
      grade: "3",
      teacher: "Ms. Thompson",
      board: "Toronto District School Board",
      school: "Maple Leaf Public School",
      address1: "100 Main Street",
      address2: "Toronto, ON M4B 1A1",
      principal: "Mr. Johnson",
      telephone: "416-555-0100",
      boardInformation1: "",
      daysAbsent: "2",
      totalDaysAbsent: "2",
      timesLate: "0",
      totalTimesLate: "0",
      responsibility: "E",
      organization: "G",
      independentWork: "G",
      collaboration: "E",
      initiative: "G",
      selfRegulation: "G",
      strengthsNextStepsLSWH:
        "Aiden demonstrates excellent responsibility and collaboration. Next steps: continue to develop independence during extended writing tasks.",
      languagePlan: "",
      languageResult: "PW",
      frenchPlan: "Core",
      frenchResult: "PW",
      nativeLanguage: "",
      nativeLanguagePlan: "",
      nativeLanguageResult: "",
      mathematicsPlan: "",
      mathematicsResult: "PW",
      scienceAndTechnologyPlan: "",
      scienceAndTechnologyResult: "PW",
      socialStudiesPlan: "",
      socialStudiesResult: "PW",
      healthEducationPlan: "",
      healthEducationResult: "PW",
      physicalEducationPlan: "",
      physicalEducationResult: "PW",
      artsHeader: "The Arts",
      arts1: "Visual Arts",
      arts1Plan: "",
      arts1Result: "PW",
      arts2: "Music",
      arts2Plan: "",
      arts2Result: "PW",
      arts3: "Drama",
      arts3Plan: "",
      arts3Result: "PW",
      arts4: "Dance",
      arts4Plan: "",
      arts4Result: "PW",
      optionalStudies: "",
      optionalStudiesPlan: "",
      optionalStudiesResult: "",
      strengthsNextStepsSubjects:
        "Aiden shows strong engagement across all subject areas. Next steps: work on written explanations in Mathematics and Science.",
      boardInformation2: "",
    },
  },
  {
    label: "Example: Sofia Martinez",
    data: {
      date: "2024-11-15",
      studentName: "Sofia Martinez",
      oen: "987654321",
      grade: "5",
      teacher: "Mr. Chen",
      board: "Toronto District School Board",
      school: "Maple Leaf Public School",
      address1: "100 Main Street",
      address2: "Toronto, ON M4B 1A1",
      principal: "Mr. Johnson",
      telephone: "416-555-0100",
      boardInformation1: "",
      daysAbsent: "4",
      totalDaysAbsent: "6",
      timesLate: "1",
      totalTimesLate: "2",
      responsibility: "G",
      organization: "S",
      independentWork: "G",
      collaboration: "G",
      initiative: "G",
      selfRegulation: "S",
      strengthsNextStepsLSWH:
        "Sofia works well with peers and shows enthusiasm in class. Next steps: develop stronger organizational strategies for longer assignments.",
      languagePlan: "IEP",
      languageResult: "PWD",
      frenchPlan: "Core",
      frenchResult: "PW",
      nativeLanguage: "",
      nativeLanguagePlan: "",
      nativeLanguageResult: "",
      mathematicsPlan: "IEP",
      mathematicsResult: "PW",
      scienceAndTechnologyPlan: "",
      scienceAndTechnologyResult: "PW",
      socialStudiesPlan: "",
      socialStudiesResult: "PW",
      healthEducationPlan: "",
      healthEducationResult: "PVW",
      physicalEducationPlan: "",
      physicalEducationResult: "PVW",
      artsHeader: "The Arts",
      arts1: "Visual Arts",
      arts1Plan: "",
      arts1Result: "PW",
      arts2: "Music",
      arts2Plan: "",
      arts2Result: "PW",
      arts3: "Drama",
      arts3Plan: "",
      arts3Result: "PVW",
      arts4: "Dance",
      arts4Plan: "",
      arts4Result: "PVW",
      optionalStudies: "",
      optionalStudiesPlan: "",
      optionalStudiesResult: "",
      strengthsNextStepsSubjects:
        "Sofia excels in Health and Physical Education. In Language, she is making progress with the support of her IEP accommodations.",
      boardInformation2: "",
    },
  },
  {
    label: "Example: Noah Williams",
    data: {
      date: "2024-11-15",
      studentName: "Noah Williams",
      oen: "111222333",
      grade: "1",
      teacher: "Ms. Patel",
      board: "Toronto District School Board",
      school: "Maple Leaf Public School",
      address1: "100 Main Street",
      address2: "Toronto, ON M4B 1A1",
      principal: "Mr. Johnson",
      telephone: "416-555-0100",
      boardInformation1: "",
      daysAbsent: "1",
      totalDaysAbsent: "1",
      timesLate: "0",
      totalTimesLate: "0",
      responsibility: "G",
      organization: "G",
      independentWork: "G",
      collaboration: "G",
      initiative: "G",
      selfRegulation: "G",
      strengthsNextStepsLSWH:
        "Noah is a thoughtful and kind student. Next steps: build confidence in sharing ideas with the class.",
      languagePlan: "",
      languageResult: "PW",
      frenchPlan: "Core",
      frenchResult: "PW",
      nativeLanguage: "",
      nativeLanguagePlan: "",
      nativeLanguageResult: "",
      mathematicsPlan: "",
      mathematicsResult: "PW",
      scienceAndTechnologyPlan: "",
      scienceAndTechnologyResult: "PW",
      socialStudiesPlan: "",
      socialStudiesResult: "PW",
      healthEducationPlan: "",
      healthEducationResult: "PW",
      physicalEducationPlan: "",
      physicalEducationResult: "PW",
      artsHeader: "The Arts",
      arts1: "Visual Arts",
      arts1Plan: "",
      arts1Result: "PW",
      arts2: "Music",
      arts2Plan: "",
      arts2Result: "PW",
      arts3: "",
      arts3Plan: "",
      arts3Result: "",
      arts4: "",
      arts4Plan: "",
      arts4Result: "",
      optionalStudies: "",
      optionalStudiesPlan: "",
      optionalStudiesResult: "",
      strengthsNextStepsSubjects:
        "Noah is making steady progress across all subject areas and approaches his learning with enthusiasm.",
      boardInformation2: "",
    },
  },
];
